// extracted by mini-css-extract-plugin
module.exports = {"box":"box--2UV6y","mainMod":"mainMod--D29LP","item":"item--3rmJj"};